import React, { useContext } from "react";
import { TextField, FormControl } from '@mui/material';
import { AppContext } from "../../App";
import Button from '@mui/material/Button';

export default function EventDetails(){

  const { eventDetails, setEventDetails } = useContext(AppContext)


  const handleChange = (e) => {
    let clonedData = eventDetails
    clonedData['eventDetails'][e.target.name] = e.target.value
    console.log(clonedData)
    setEventDetails(clonedData)
  }

  return (

    <div className="event-details">
      <h3 className="section-title">
        Event details
      </h3>

      <div className="event-inputs">
        <TextField name="eventName" sx={{marginBottom: 2}}  id="outlined-name" label="Event Name" onChange={(e)=> handleChange(e)} defaultValue={eventDetails.eventDetails.eventName} />
        <TextField name="bandName" sx={{marginBottom: 2}} disabled  id="outlined-disabled" label="Band/ Performer" defaultValue={eventDetails.bandName} />
        <TextField name="eventDate" sx={{marginBottom: 2}}  id="outlined-name" label="Date(s) of Event" onChange={(e)=> handleChange(e)} defaultValue={eventDetails.eventDetails.eventDate} />
        <TextField name="performTime" sx={{marginBottom: 2}}  id="outlined-name" label="Performance Time" onChange={(e)=> handleChange(e)} defaultValue={eventDetails.eventDetails.performTime} />
        <TextField name="performDuration" sx={{marginBottom: 2}}  id="outlined-name" label="Performance Duration" onChange={(e)=> handleChange(e)} defaultValue={eventDetails.eventDetails.performDuration} />
        <TextField name="soundcheckTime" sx={{marginBottom: 2}}  id="outlined-name" label="Soundcheck Time" onChange={(e)=> handleChange(e)} defaultValue={eventDetails.eventDetails.soundcheckTime}/>
        <TextField name="venueName" sx={{marginBottom: 2}}  id="outlined-name" label="Venue Name" onChange={(e)=> handleChange(e)} defaultValue={eventDetails.eventDetails.venueName} />
        <TextField name="venueAddress" sx={{marginBottom: 2}}  id="outlined-name" label="Venue Address" onChange={(e)=> handleChange(e)} defaultValue={eventDetails.eventDetails.venueAddress} />
        <TextField name="performFee" sx={{marginBottom: 2}} disabled  id="outlined-disabled" label="Performance Fee" defaultValue={eventDetails.eventDetails.performFee}/>
        <TextField name="addFee" sx={{marginBottom: 2}} disabled  id="outlined-disabled" label="Additional Fee(s)" defaultValue={eventDetails.eventDetails.addFee} />
        <TextField name="payTerms" sx={{marginBottom: 2}} disabled  id="outlined-disabled" label="Payment Terms" defaultValue={eventDetails.eventDetails.payTerms}/>
      </div>
    </div>

  )
}
